import React, { useState } from 'react';
import Modal from 'react-modal';
import { motion } from 'framer-motion';
import Avatar1 from '../images/homepage/img1.png';
import Avatar2 from '../images/homepage/img2.png';
import Avatar3 from '../images/homepage/img3.png';
import Aboutimg from '../images/homepage/home1.png';
import Aboutbgimg from '../images/homepage/bg1.png';
import './HeroStats.css';

Modal.setAppElement('#root');

const HeroStats = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <div className="about-section">
        <motion.div 
          className="about-left"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <motion.div 
            className="inr-abtsc"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h2>
              Built to <span className="highlight">Simplify.</span><br />
              Driven by <span className="highlight">Innovation.</span>
            </h2>
          </motion.div>
          <motion.div 
            className="inr-abtsc"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <p>
              At ServTrackr, we believe that managing a service business shouldn't be complicated.
              That's why we've built a platform that cuts through the clutter — helping you schedule jobs,
              manage teams, and serve customers effortlessly.
            </p>
          </motion.div>
        </motion.div>

        <motion.div 
          className="about-right"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
          viewport={{ once: true }}
        >
          <motion.div 
            className="stats-card" 
            style={{
             backgroundImage: `url(${Aboutbgimg})`,
              backgroundRepeat: 'no-repeat',
             backgroundPosition: 'top',
              backgroundSize: 'cover',
            padding: '3em',
            overflow: 'hidden',}}
            whileHover={{ scale: 1.02, y: -5 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <motion.h2
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 0.5 }}
            >
              24K<span className="plus">+</span>
            </motion.h2>
            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.7 }}
            >
              Projects Completed Successfully
            </motion.p>
            <motion.div 
              className="avatars"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.9 }}
            >
              <motion.img 
                src={Avatar1} 
                alt="user1" 
                whileHover={{ scale: 1.1 }}
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                transition={{ delay: 1.0, type: "spring" }}
              />
              <motion.img 
                src={Avatar2} 
                alt="user2" 
                whileHover={{ scale: 1.1 }}
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                transition={{ delay: 1.1, type: "spring" }}
              />
              <motion.img 
                src={Avatar3} 
                alt="user3" 
                whileHover={{ scale: 1.1 }}
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                transition={{ delay: 1.2, type: "spring" }}
              />
              <motion.div 
                className="plus-circle" 
                onClick={openModal}
                whileHover={{ scale: 1.2, rotate: 90 }}
                whileTap={{ scale: 0.9 }}
                initial={{ scale: 0 }}
                whileInView={{ scale: 1 }}
                transition={{ delay: 1.3, type: "spring" }}
              >
                +
              </motion.div>
            </motion.div>
            <motion.span 
              className="join-text"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 1.1 }}
            >
              100K+ People Join
            </motion.span>
          </motion.div>

          <motion.div 
            className="video-box" 
            style={{
             backgroundImage: `url(${Aboutimg})`,
              backgroundRepeat: 'no-repeat',
             backgroundPosition: 'top',
              backgroundSize: 'cover',
            padding: '3em',
            overflow: 'hidden',
          }}
            whileHover={{ scale: 1.02, y: -5 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <motion.button 
              className="play-btn" 
              onClick={openModal}
              whileHover={{ 
                scale: 1.1,
                boxShadow: "0 10px 30px rgba(139, 92, 246, 0.4)"
              }}
              whileTap={{ scale: 0.95 }}
              animate={{
                boxShadow: [
                  "0 0 0 0 rgba(139, 92, 246, 0.7)",
                  "0 0 0 10px rgba(139, 92, 246, 0)",
                  "0 0 0 0 rgba(139, 92, 246, 0)"
                ]
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            >
              ▶
            </motion.button>
          </motion.div>
        </motion.div>

        <Modal
          isOpen={isModalOpen}
          onRequestClose={closeModal}
          contentLabel="Video Modal"
          className="modal"
          overlayClassName="overlay"
        >
          <button onClick={closeModal} className="close-btn">✖</button>
          <iframe
            width="100%"
            height="400"
            src="https://www.youtube.com/embed/dQw4w9WgXcQ"
            title="Demo Video"
            frameBorder="0"
            allowFullScreen
          ></iframe>
        </Modal>
      </div>
    </>
  );
};

export default HeroStats;
